export const appKey = "easemob#easeim"; // 环信AppKey
export const APP_ID = "15cb0d28b87b425ea613fc46f7c9f974"; // 声网AppId
export const UIKIT_VERSION = "1.4.0";
export const SDK_VERSION = "4.11.0";
export const DEMO_VERSION = "2.2.0";

export const PRESENCE_CONFIG = [
  "Online",
  "Offline",
  "Away",
  "Busy",
  "Do Not Disturb",
  "Custom",
];
